module.exports = __webpack_public_path__ + "img/AU.45cc90f9.png";